import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';

function App() {
  return (
 <>
 <Navbar />
 <Home />
 </>
  );
}

export default App;
